/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown>, used: NonNullable<unknown> }} Ticketscapline2Inputs */

const en_ticketscapline2 = /** @type {(inputs: Ticketscapline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Until your first event with paid tickets has taken place, you can sell tickets for up to ${i?.limit}. So far: ${i?.used}.`)
};

const de_ticketscapline2 = /** @type {(inputs: Ticketscapline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis dein erstes Event mit bezahlten Tickets vorbei ist, verkaufst du Tickets für bis zu ${i?.limit}. Bisher: ${i?.used}.`)
};

/**
* | output |
* | --- |
* | "Until your first event with paid tickets has taken place, you can sell tickets for up to {limit}. So far: {used}." |
*
* @param {Ticketscapline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketscapline2 = /** @type {((inputs: Ticketscapline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketscapline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketscapline2(inputs)
	return de_ticketscapline2(inputs)
});
export { ticketscapline2 as "ticketsCapLine" }